import { getPref, setPref } from '../persistentPrefs';
import { k } from '../../localization/t';

const STORAGE_KEY = 'fab-arena-sound-settings';

const defaults = {
  masterVolume: 0.7,
  musicVolume: 0.5,
  sfxVolume: 0.8,
  musicEnabled: true,
  sfxEnabled: true,
};

let cached = null;

export function getSoundSettings() {
  if (cached) return cached;
  const stored = getPref(STORAGE_KEY, null);
  cached = stored && typeof stored === 'object' ? { ...defaults, ...stored } : { ...defaults };
  return cached;
}

export function saveSoundSettings(settings) {
  cached = { ...(cached || defaults), ...settings };
  setPref(STORAGE_KEY, cached);
}

export function getEffectiveMusicVolume() {
  const s = getSoundSettings();
  return s.musicEnabled ? s.masterVolume * s.musicVolume : 0;
}

export function getEffectiveSfxVolume() {
  const s = getSoundSettings();
  return s.sfxEnabled ? s.masterVolume * s.sfxVolume : 0;
}

// Which social notifications ring the soft ping. `kinds` are the server's
// notify() kinds plus the legacy poll types that mean the same thing. Absent
// from settings means on; only an explicit false mutes.
export const NOTIFICATION_SOUND_OPTIONS = [
  { key: 'messages', label: k('Direct Messages'), hint: k('A friend sends you a message.'), kinds: ['chat.message'] },
  { key: 'mentions', label: k('Mentions'), hint: k('Someone mentions you in the Tavern.'), kinds: ['chat.mention'] },
  { key: 'replies', label: k('Replies'), hint: k('Someone replies to you in the Tavern.'), kinds: ['chat.reply'] },
  { key: 'reactions', label: k('Reactions'), hint: k('Someone reacts to your message, deck notes or replay comment.'), kinds: ['chat.like', 'deck.like', 'deck.comment.like', 'replay.like'] },
  { key: 'comments', label: k('Comments'), hint: k('Someone comments on your deck or replay.'), kinds: ['deck.comment', 'replay.comment'] },
  { key: 'friends', label: k('Friend Requests'), hint: k('A request arrives or is accepted.'), kinds: ['friend.request', 'friend.accepted', 'friend-request', 'friend-accepted'] },
];
const OPTION_BY_KIND = new Map(NOTIFICATION_SOUND_OPTIONS.flatMap((o) => o.kinds.map((k) => [k, o.key])));

export function notificationSoundEnabled(kind) {
  const key = OPTION_BY_KIND.get(kind);
  if (!key) return true;
  return getSoundSettings().notificationSounds?.[key] !== false;
}
